import React, {} from "react";
import IconCarFront from "../../assets/v2/car-front.png";
import IconTimer from "../../assets/v2/timer.png";
import IconTimerGreen from "../../assets/v2/timer_green.png";
import FormatUtils from "../../utils/FormatUtils";
import {RouteType} from "./constants/RouteType";
import moment from "moment";
import Price from "../../components/v2/Price";
import {OrderStatus} from "../../constants/OrderStatus";
import IconClose from "../../assets/v2/close_circle_yellow.png";
import ValetRouteGraph from "./ValetRouteGraph";
import {useTranslation} from "react-i18next";

// Inspiré de ServiceCardModal et ValetSummary
export default function ValetServiceCard({
                                             closeHandler,
                                             disputeLinkClickedHandler,
                                             orderData
                                         }) {
    const {t} = useTranslation('common');

    const FormatGoogleAdress = (address) => {
        return address.split(',').map((it, i) => <div key={'x' + i}>{it}</div>)
    }

    const date = moment(orderData.date);
    const now = moment();
    const time = now.clone().set({
        hour: orderData.time.split(':')[0],
        minute: orderData.time.split(':')[1]
    });

    const retrieveTime = orderData.retrieve_at ? now.clone().set({
        hour: orderData.retrieve_at.split(':')[0],
        minute: orderData.retrieve_at.split(':')[1]
    }) : null;

    const valetIntent = orderData.valet_intent;

    return <div className="h-full flex flex-col p-4 gap-4 font-DMSans bg-gray-800 text-white">
        <div className="flex justify-between items-center">
            <div className="text-sm text-gray-400">{t('valet.service_card.title')}</div>
            <img src={IconClose} alt="Close" className={"m-1 h-[24px] cursor-pointer"}
                 onClick={closeHandler}/>
        </div>
        <div className="flex flex-nowrap justify-between items-center">
            <div className="flex flex-col">
                <div className="text-white text-[30px] font-bold">{t('valet.service_card.text')}</div>
                <div className="text-gray-400 text-[12px]">{t('valet.service_card.text2')} <br/>N°{orderData.number}</div>
                {
                    orderData.order_status_id === OrderStatus.CANCELED_BY_CUSTOMER ?
                        <div className="text-red-200 text-[12px]">{t('valet.service_card.text3')}</div> : null
                }
            </div>
            <Price value={valetIntent.price}/>
        </div>
        <div>
            {t('valet.service_card.text4')}<b>{valetIntent.route_type === RouteType.GOING ? t('valet.service_card.route_type_going') : t('valet.service_card.route_type_going_and_coming')}</b> {t('valet.service_card.of')} {FormatUtils.formatDistance(valetIntent.gmap_distance)}.
        </div>

        <div className="flex flex-nowrap justify-between items-center gap-3">
            <div
                className="rounded-xl bg-white font-bold text-black flex flex-col justify-center items-center p-1 w-1/6">
                <div><b>{date.format('ddd').toUpperCase()}</b></div>
                <div className="text-red-600 text-4xl mt-[-8px] mb-[-6px]">{date.format('D')}</div>
                <div className="text-xs"><b>{date.format('MMM').toUpperCase()}</b></div>
            </div>
            <div className="flex-grow h-full rounded-2xl bg-[#cdcdcd] text-black flex items-center w-5/6">
                <div><img className="m-5" src={IconCarFront} alt="car"/></div>
                <div className="flex-grow"><b>{orderData.vehicle.model}</b>
                    <br/>{t('valet.service_card.text5')} {orderData.vehicle.licence_plate}
                </div>
            </div>
        </div>


        <fieldset className="border border-solid border-gray-300 p-3 rounded-2xl mt-4">
            <legend className="text-sm">&nbsp;{t('valet.service_card.text6')}&nbsp;</legend>
            <div className="flex mt-1 mb-3 text-[#9bff72]">
                <div className="w-[32px] mr-3"><img src={IconTimerGreen} className="mx-auto max-w-xs"/></div>
                <div><b>{t('valet.service_card.text7')} {time.format('HH')}H{time.format('mm')}</b></div>
            </div>
            <div className="flex">
                <ValetRouteGraph routeType={valetIntent.route_type}/>
                <div className="grow">
                    <div><b>{t('valet.service_card.text8')}</b></div>
                    {FormatGoogleAdress(valetIntent.gmap_origin)}
                    <div>{t('valet.service_card.contact')} {orderData.customer_phone}</div>
                    <div className="mt-10"></div>
                    <div><b>{t('valet.service_card.text9')}</b></div>
                    {FormatGoogleAdress(valetIntent.gmap_destination)}
                    <div>{t('valet.service_card.contact')} {orderData.delivery_contact_phone}</div>
                </div>
            </div>
            {retrieveTime ?
                <div className="flex mt-5 mb-3 text-[#f9b712]">
                    <div className="w-[32px] mr-3"><img src={IconTimer} className="mx-auto max-w-xs"/></div>
                    <div><b>{t('valet.service_card.text10')} {retrieveTime.format('HH')}H{retrieveTime.format('mm')}</b></div>
                </div> : null}
        </fieldset>
        <div className="grow">
        </div>
        <div className="text-[#ffbc00] text-sm cursor-pointer" onClick={disputeLinkClickedHandler}><u>{t('valet.service_card.text11')}</u></div>
    </div>
}